import type { BulkEmail } from "@/schema"
import { useQuery, UseQueryOptions } from "@tanstack/react-query"

import { useApiContext } from "@/hooks/api/use-api-context"

import { fetchBulkEmail, fetchBulkEmails } from "./api"

export function useFetchBulkEmails(enabled?: boolean) {
  const getContext = useApiContext()
  return useQuery({
    queryKey: ["bulk_emails"],
    queryFn: async () => {
      const context = await getContext()
      if (!context) throw new Error("No context found")
      return fetchBulkEmails(context)
    },
    enabled,
  })
}

export function useFetchBulkEmail(id: string, options?: Omit<UseQueryOptions<BulkEmail>, "queryKey" | "queryFn">) {
  const getContext = useApiContext()
  return useQuery({
    queryKey: ["bulk_email", id],
    queryFn: async () => {
      const context = await getContext()
      if (!context) throw new Error("No context found")
      return fetchBulkEmail(context, id)
    },
    enabled: options?.enabled !== undefined ? options.enabled : !!id,
    ...options,
  })
}
